export default {
  methods: {
    getBranch () {
      this.$axios
      .get('branch?status=active&all=all', {
        headers: { Authorization: 'Bearer ' + localStorage.token }
      })
      .then((response) => response.data)
      .then((data) => {
        var branchRecord = []
        branchRecord = data.data
        if (branchRecord.length === 1) {
          this.branch = branchRecord[0]
        }
        this.branches = data.data
        console.log('=====branch length=========')
      })
      .catch(
        function (error) {
          Toast.fire({ icon: 'error', title: 'Please Try Again' })
          this.form.errors.errors = error.response.data.error
        }.bind(this)
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/BranchRecords.js